import { Fade } from "react-awesome-reveal";
import Intro_1 from "../../../assets/images/intro_1.svg";

const FirstStep = ({ setStep }: { setStep: any }) => {
  return (
    <div className="px-10 bg-white h-screen flex flex-col items-center justify-center">
      <Fade triggerOnce>
        <div className="flex flex-col items-center justify-between">
          <img
            src={Intro_1}
            alt="بادی‌بان"
            className="w-full max-w-xs lg:w-6/12 mb-10"
          />
          <div className="flex flex-col items-center justify-center">
            <h2 className="text-xl text-right max-w-3xl font-rokh font-[700] lg:w-9/12 leading-relaxed">
              یه سوال، <br />
              دوست داری خودت بتونی برگه آزمایشت رو بخونی و بفهمی توش چی نوشته؟
              <br /> یا می‌خوای به بدنت گوش بدی و رمزگشاییش کنی؟
            </h2>
            <button
              className="text-pr_primary font-bold text-xl btn btn-outline btn-wide w-full lg:w-4/12 mt-16"
              onClick={() => setStep(2)}
            >
              ادامـــه
            </button>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default FirstStep;
